<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dramatis Personae</span></p>
<p class="P_WFP_BodyTextFirstPara__And__Left_Indent">(Historical figures are denoted by <span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>)</p>
<p class="P_WFP_DramatisText">Jean-Claude (Rod) Simone</p>
<p class="P_WFP_DramatisText">Marie Simone—Rod’s mother</p>
<p class="P_WFP_DramatisText">Henri Simone—Rod’s father</p>
<p class="P_WFP_DramatisText">Nanette Simone—Rod’s sister</p>
<p class="P_WFP_DramatisText">Major General Hank McCluney—Downed pilot, Rod’s adoptive father</p>
<p class="P_WFP_DramatisText">Mary McCluney—Hank’s wife, Rod’s adoptive mother</p>
<p class="P_WFP_DramatisText">Sandy Allison—Rod’s high-school girlfriend in Southern California</p>
<p class="P_WFP_DramatisText">Julie Phillips—Colorado Women’s College student, Rod’s girlfriend in Colorado</p>
<p class="P_WFP_DramatisLocation__And__Left_Indent">United States Air Force Academy—Class of 1959</p>
<p class="P_WFP_DramatisText">Nino Baldacci<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—Cadet (Poughkeepsie, NY)</p>
<p class="P_WFP_DramatisText">Fred Delante—Cadet (Colorado Springs, CO)</p>
<p class="P_WFP_DramatisText">Jeff Goldstein—Cadet (New York, NY)</p>
<p class="P_WFP_DramatisText">Sylvester “Sly” Winston Jakes—Cadet (Boston, MA)</p>
<p class="P_WFP_DramatisText">Manuel Rojo—Cadet (Albuquerque, NM)</p>
<p class="P_WFP_DramatisText">George Sanders—Cadet (Ft. Worth, Texas)</p>
<p class="P_WFP_DramatisLocation__And__Left_Indent">United States Air Force Academy</p>
<p class="P_WFP_DramatisText">Master Sergeant William H. Coltrin<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—USAFA Non-commissioned OIC</p>
<p class="P_WFP_DramatisText">Lieutenant General James E. Briggs<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—USAFA Superintendent</p>
<p class="P_WFP_DramatisText">Raf Garcia—waiter</p>
<p class="P_WFP_DramatisText">Lieutenant General Hubert Harmon<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—first USAFA Superintendent</p>
<p class="P_WFP_DramatisText">Captain Samuel P. Justice, USAF—Air Officer Commanding (AOC)</p>
<p class="P_WFP_DramatisText">Ben Martin<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—USAFA football coach</p>
<p class="P_WFP_DramatisText">Mrs. Gail McComas<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;"> ψ</span>—Cadet hostess, 1955 to 1977</p>
<p class="P_WFP_DramatisText">First Lieutenant Tom Ranch, USAF—Air Training Officer (ATO)</p>
<p class="P_WFP_DramatisText">Brigadier General Robert M. “Moose” Stillman<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—first Commandant of Cadets</p>
<p class="P_WFP_DramatisText">Brigadier Henry R. Sullivan, Jr.<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—Commandant of Cadets</p>
<p class="P_WFP_DramatisText">Colonel Albert E. Stoltz<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—Director, Air Force Academy Construction Agency</p>
<p class="P_WFP_DramatisLocation__And__Left_Indent">Colorado Springs</p>
<p class="P_WFP_DramatisText">George Delante—Land developer and construction magnate</p>
<p class="P_WFP_DramatisText">Elizabeth Delante—his wife</p>
<p class="P_WFP_DramatisText">Jim-Tom Henderson—Owner, Pine Valley Airport and George’s business partner</p>
<p class="P_WFP_DramatisText">Margaret Henderson—his sister</p>
<p class="P_WFP_DramatisText">Darius Moore—El Paso county assistant district attorney</p>
<p class="P_WFP_DramatisLocation__And__Left_Indent">Washington, D.C.</p>
<p class="P_WFP_DramatisText">President Dwight D. Eisenhower<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—U. S. President</p>
<p class="P_WFP_DramatisText">The Honorable J. Edgar Chenoweth<span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">ψ</span>—Colorado Congressman</p>
<p class="P_WFP_DramatisText">Ambassador T. Edward Phillips—Julie Phillip’s father</p>
<p class="P_WFP_DramatisText">Francine Phillips—Julie Phillip’s mother</p>
<p class="P_WFP_DramatisLocation__And__Left_Indent">Other Locations</p>
<p class="P_WFP_DramatisText">Colonel “Speedy” Beaumont—Hank McCluney’s wingman in WWII</p>
<p class="P_WFP_DramatisText">Carol Gutheinz—Colorado Women’s College student</p>
<p class="P_WFP_DramatisText">Tony Rafelli—<i>Denver Post</i> reporter</p>
<p class="P_WFP_DramatisText">Barbara Richardson—Stanford student</p>
<p class="P_WFP_DramatisText">Wendy Shelby—Colorado Women’s College student</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0007.vue?226f46f9